import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OnboardingRouter from '../Components/OnboardingRouter';
import GettingStarted from '../pages/GettingStarted/GettingStarted';
import EmailVerification from '../pages/EmailVerification/EmailVerification';
import SelectPlans from '../pages/SelectPlans/SelectPlans';
import CreateOrganization from '../pages/CreateOrganization/CreateOrganization';
import ConfigureStructure from '../pages/ConfigureStructure/ConfigureStructure';
import Complete from '../pages/Complete/Complete';
import PaymentVerification from '../pages/PaymentVerification/PaymentVerification';

const AllRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<OnboardingRouter />} />
      <Route path="/resume" element={<OnboardingRouter />} />
      <Route path="/getting-started" element={<GettingStarted />} />
      <Route path="/verify-email" element={<EmailVerification />} />
      <Route path="/select-plans" element={<SelectPlans />} />
      <Route path="/payment-verification" element={<PaymentVerification />} />
      <Route path="/create-organization" element={<CreateOrganization />} />
      <Route path="/configure-structure" element={<ConfigureStructure />} />
      <Route path="/complete" element={<Complete />} />
      {/* Keep old route for compatibility */}
      <Route path="/organization-setup" element={<CreateOrganization />} />
    </Routes>
  );
};

export default AllRoutes;